import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default config => {
    const getPlayer = playerObj => {
        let { player } = playerObj;
        let loggedIn = player ? true : false;

        if (loggedIn) {
            return {
                loggedIn: loggedIn,
                player: {
                    name: player.firstname + ' ' + player.lastname,
                    email: player.email,
                    first_name: player.firstname,
                    last_name: player.lastname,
                    email_confirm: player.email,
                    // TODO:
                    // VALUES FROM NON PASSTHROUGH THAT WOULD BE NEEDED FOR ACCOUNT PAGE
                    // player_id: player.id,
                    // address1: player.address1,
                    // address2: player.address2,
                    // city: player.city,
                    // state: player.state,
                    // zip: player.zip,
                    // phone1: player.phone1,
                    // area_phone1: player.phone1.split('-')[0],
                    // prefix_phone1: player.phone1.split('-')[1],
                    // suffix_phone1: player.phone1.split('-')[2],
                    // phone2: player.phone2,
                    // area_phone2: player.phone2.split('-')[0],
                    // prefix_phone2: player.phone2.split('-')[1],
                    // suffix_phone2: player.phone2.split('-')[2],
                    // dob_year: player.dob.split('-')[0],
                    // dob_month: player.dob.split('-')[1],
                    // dob_day: player.dob.split('-')[2],
                },
            };
        } else {
            return {
                loggedIn: false,
            };
        }
    };

    return async payload => {
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);

        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            if (!spatFromCookie && jwtFromCookie) {
                let result = await apiClient(config).apiMethod({
                    method: 'getSpatWithJwt',
                    headers: {
                        Authorization: jwtFromCookie,
                    },
                });

                return getPlayer(result);
            } else if (spatFromCookie) {
                return getPlayer(JSON.parse(spatFromCookie));
            } else {
                return {
                    loggedIn: false,
                };
            }
        } else {
            return {
                loggedIn: false,
            };
        }
    };
};
